module.exports = __webpack_public_path__ + "static/media/computer-focused.98735cc1.png";